import ContentLoader from "@rio-cloud/rio-uikit/ContentLoader";

const BANNER_ICON_SIZE = 18;
const BANNER_TEXT_HEIGHT = 20;
const SECTION_TITLE_HEIGHT = 20;
const MAP_HEIGHT = 150;
const DATA_LABEL_HEIGHT = 15;
const DATA_VALUE_HEIGHT = 21;
const CARD_LABEL_HEIGHT = 17;
const CARD_VALUE_HEIGHT = 29;

const LOADER_CLASS = "display-block skeleton-on-highlight-bg";

const SECTION_TITLE_WIDTHS = [90, 120, 140];
const BANNER_TEXT_WIDTHS = [220, 260];
const DATA_LABEL_WIDTHS = [70, 95, 55, 65];
const DATA_VALUE_WIDTHS = [150, 175, 90, 130];
const CARD_LABEL_WIDTHS = [110, 130];
const CARD_VALUE_WIDTHS = [80, 95];

const renderBanner = (index: number) => (
  <div className="display-flex align-items-center gap-10 padding-10 rounded border border-width-1 border-color-light">
    <ContentLoader className={LOADER_CLASS} height={BANNER_ICON_SIZE} width={BANNER_ICON_SIZE} />
    <ContentLoader
      className={LOADER_CLASS}
      height={BANNER_TEXT_HEIGHT}
      width={BANNER_TEXT_WIDTHS[index % BANNER_TEXT_WIDTHS.length]}
    />
  </div>
);

const renderSectionTitle = (index: number) => (
  <span className="display-block margin-top-20 text-color-gray text-size-14 text-medium">
    <ContentLoader
      className={LOADER_CLASS}
      height={SECTION_TITLE_HEIGHT}
      width={SECTION_TITLE_WIDTHS[index % SECTION_TITLE_WIDTHS.length]}
    />
  </span>
);

const renderDataPair = (index: number) => (
  <div className="width-50pct display-flex flex-column gap-5">
    <ContentLoader
      className={LOADER_CLASS}
      height={DATA_LABEL_HEIGHT}
      width={DATA_LABEL_WIDTHS[index % DATA_LABEL_WIDTHS.length]}
    />
    <ContentLoader
      className={LOADER_CLASS}
      height={DATA_VALUE_HEIGHT}
      width={DATA_VALUE_WIDTHS[index % DATA_VALUE_WIDTHS.length]}
    />
  </div>
);

const renderDataCard = (index: number) => (
  <div className="flex-1-1 display-flex flex-column align-items-center justify-content-center gap-5 height-80 rounded border border-width-1 border-color-light">
    <ContentLoader
      className={LOADER_CLASS}
      height={CARD_LABEL_HEIGHT}
      width={CARD_LABEL_WIDTHS[index % CARD_LABEL_WIDTHS.length]}
    />
    <ContentLoader
      className={LOADER_CLASS}
      height={CARD_VALUE_HEIGHT}
      width={CARD_VALUE_WIDTHS[index % CARD_VALUE_WIDTHS.length]}
    />
  </div>
);

export default function AlertsHistoryDetailSkeleton() {
  return (
    <>
      {renderBanner(0)}

      {renderSectionTitle(0)}
      <div className="margin-top-10 rounded overflow-hidden border border-width-1 border-color-light">
        <ContentLoader className={LOADER_CLASS} height={MAP_HEIGHT} width="100%" />
      </div>

      <hr className="margin-top-20 margin-bottom-0 border-color-light" />
      {renderSectionTitle(1)}

      <div className="display-flex margin-top-15">
        {renderDataPair(0)}
        {renderDataPair(1)}
      </div>

      <hr className="margin-top-15 margin-bottom-0 border-color-light" />

      <div className="display-flex margin-top-15">
        {renderDataPair(2)}
        {renderDataPair(3)}
      </div>

      <hr className="margin-top-15 margin-bottom-0 border-color-light" />

      <div className="display-flex align-items-center justify-content-between margin-top-15">
        <div className="display-flex align-items-center gap-5">
          <ContentLoader className={LOADER_CLASS} height={16} width={16} />
          <ContentLoader className={LOADER_CLASS} height={20} width={100} />
        </div>
        <ContentLoader className={LOADER_CLASS} height={20} width={70} />
      </div>

      <hr className="margin-top-15 margin-bottom-0 border-color-light" />

      {renderSectionTitle(2)}
      <div className="display-flex gap-10 margin-top-15">
        {renderDataCard(0)}
        {renderDataCard(1)}
      </div>

      <div className="margin-top-10">{renderBanner(1)}</div>
    </>
  );
}
